import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QuestionTypeBaseComponent } from '../../../base/question-type-base.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'medrecord-text-question',
  templateUrl: './text-question.component.html',
  styleUrls: ['./text-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextQuestionComponent extends QuestionTypeBaseComponent {

  constructor(protected fb: FormBuilder) {
    super(fb);
  }

}

